import {
    Alert,
    AlertIcon,
    Box,
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useColorModeValue,
} from '@chakra-ui/react';
import { translate } from '../../../i18n';

interface DeleteConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading: boolean;
    commentContent: string;
}

export default function DeleteConfirmationModal({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
    commentContent,
}: DeleteConfirmationModalProps) {
    const quoteBg = useColorModeValue('gray.50', 'gray.600');
    const truncatedContent = commentContent.length > 100
        ? commentContent.substring(0, 100) + '...'
        : commentContent;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{translate('admin_comments.delete_comment')}</ModalHeader>
                <ModalCloseButton />

                <ModalBody>
                    <Alert status="warning" mb={4}>
                        <AlertIcon />
                        {translate('admin_comments.delete_warning')}
                    </Alert>

                    <Text mb={3}>
                        {translate('admin_comments.delete_confirmation')}
                    </Text>

                    <Box bg={quoteBg} p={3} borderRadius="md" borderLeft="4px solid" borderLeftColor="gray.300">
                        <Text fontSize="sm" color="gray.600" fontStyle="italic">
                            "{truncatedContent}"
                        </Text>
                    </Box>
                </ModalBody>

                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={onClose} isDisabled={isLoading}>
                        {translate('common.cancel')}
                    </Button>
                    <Button
                        colorScheme="red"
                        onClick={onConfirm}
                        isLoading={isLoading}
                    >
                        {translate('admin_comments.delete')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
